export default __webpack_public_path__ + "static/media/ic-loading.494aea7b.svg";